module.exports = __webpack_public_path__ + "static/media/user_profile_male.bec872e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_profile_male.jpg
// module id = 118
// module chunks = 0